<template>

    <v-page-widget title="Events" actionTitle="Edit" :actionFunc="editEvents" :empty="!summaries.length">
        <template #body v-if="!summaries.length">
            <v-notice size="sm" message="No Events" />
        </template>
        <template #body v-else>
            <div class="event" v-for="summary in summaries" :key="summary.id">
                <div class="action">
                    <v-swatch class="mr-10" :size="16" :color="summary.event.color" />
                    <router-link :to="{ name: 'customer-events', params: { id: customer.id }, query: { event_id: summary.event.id }}">{{ summary.event.name }}</router-link>
                </div>
                <span class="count">{{ summary.count | numeral('0.[0]a') }}</span>
            </div>
        </template>
    </v-page-widget>

</template>

<style scoped lang="scss">

    .event {
        align-items: center;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        overflow: hidden;
        &:last-child {
            margin-bottom: 0;
        }
        .action {
            @include font-medium(13px);
            align-items: center;
            display: flex;
            max-width: 80%;
            min-width: 0;
            a {
                color: $color-text;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                &:hover {
                    text-decoration: underline;
                }
            }
        }
        .count {
            @include font-medium(13px);
            color: $color-muted;
            max-width: 20%;
            min-width: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

</style>

<script>

export default {

    props: {
        customer: {
            type: Object,
            required: true,
        }
    },

    computed: {

        summaries() {
            let summaries = this.customer.event_summaries;
            return summaries.filter(s => s.event && s.event.deleted_at === null);
        },

    },

    methods: {

        editEvents() {
            this.$router.push({ name: 'events' });
        },

    },

}

</script>
